export enum SortingOrder {
  Ascending,
  Descending,
}
